import { ReactSortable } from "react-sortablejs";
import returnIcon from "../../../../../assets/img/modals/return.svg";
import { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { hideLoader, showLoader } from "../../../../loader";
import { apiUrl } from "../../../../../utils/url";
import FormFieldError from "../../../../errors/formFieldError";
import tickIconPrimary from "../../../../../assets/img/white-tick-icon.svg";
import ErrorMessage from "../../../../errors/errorMessage";
import CroppieModal from "../../../../croppie-modal";
import { toast } from "react-toastify";
import removeicon from "../../../../../assets/img/products/removeicon.svg";
import SelectedThemeInput from "../../../../custom-theme/commons/select-theme-input";
import SelectedCustomTheme from "../../../../custom-theme/commons/select-custom-theme";
import lightmodeicon from "../../../../../assets/img/products/lightmodeicon.svg";
import { Modal, NavLink } from "react-bootstrap";
import closeIcon from "../../../../../assets/img/modals/close-icon.svg"
import dots from "../../../../../assets/img/Dots1.svg"
import { createFormdataValues } from "../../../../../utils/createFormdataValues";
import { audiencePosts } from "../../../../../services/postRequests/audience";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

const ExportSteps = ({ subscribers_length, show, setShow, product_id }) => {
    const [importType, setImportType] = useState("csv");
    const [modalStep, setModalStep] = useState(1);
    const [uploadedFile, setUploadedFile] = useState(null);
    const refUpload = useRef(null);
    const history = useHistory(null);
    const dispatch = useDispatch();
    const [mappingFieldModal, setmappingFieldModal] = useState(false);
    const [subscribersName, setsubscribersName] = useState([])
    const [subscribersEmail, setsubscribersEmail] = useState([]);
    const [subscribersCompanyName, setsubscribersCompanyName] = useState([]);
    const [subscribersLength, setsubscribersLength] = useState();
    const [showExportModal, setShowExportModal] = useState(true);
    const [credits, setCredits] = useState(null);
    const { slug, basePath } = useSelector(state => state?.slugReducer);
    const [csvColumns, setCsvColumns] = useState([]);
    const [mappedData, setMappedData] = useState([]);
    const [manualData, setManualData] = useState({});
    const variables = useSelector(state => state?.variablesReducer);
    const [newVariable, setNewVariable] = useState();
    const creditsDataReducer = useSelector(state => state?.creditsDataReducer)
    const [formValues, setformValues] = useState({
        subscriber_name_index: "0", subscriber_email_index: "0", subscriber_company_name_index: "0", project: slug, csv_file: null,
        remove_duplicate: true,
    })
    const [error, setError] = useState([])
    const [showProcessingText, setShowProcessingText] = useState(false);
    const [rowsData, setRowsData] = useState({duplicate:0,total_pages:0,unique_pages:0});
    const [isGenerateDisabled, setIsGenerateDisabled] = useState(true)
    const handleClose = () => {
        setUploadedFile(null);
        setShowExportModal(false);
        // setShow({show:false, from:null})
    }
    const toggleImportType = (type) => {
        setImportType(type);
    };
    const dropzoneWrapperClick = () => {
        refUpload.current?.click();
    }
    const dropzoneWrapperDrop = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setUploadedFile(null)
        if (e.dataTransfer.files[0].type !== "text/csv")
            toast.error("Please select a CSV file");
        else setUploadedFile(e.dataTransfer.files)
        e.currentTarget.classList.remove('drag-over');
    }
    const dropzoneWrapperDrag = (e) => {
        e.preventDefault();
        e.stopPropagation();
        // $(e.target).addClass('dragover');
        e.currentTarget.classList.add('drag-over');
    }

    const dropzoneWrapperLeave = (e) => {
        e.preventDefault();
        e.stopPropagation();
        // $(e.target).removeClass('dragover');
        e.currentTarget.classList.remove('drag-over');
    }
    const handleChange = (e) => {
        setUploadedFile(e.target.files)
        uploadCSV(e)
    };
    const uploadCSV = (e) => {
        e.preventDefault();
        mappingFile(e.target.files)
    }
    const mappingFile = (files) => {
        showLoader();
        setError([])
        setMappedData([]);
        if (files?.length > 0) {

            var file = files[0];
            var reader = new FileReader();
            reader.readAsText(file);
            reader.onload = function (event) {
                var csv = event.target.result;
                var data = csv.split("\n");
                const csv_cols = data[0].split(",");
                if (csv_cols.length < 3) {
                    setUploadedFile(null);
                    toast.error("Please upload a CSV file with at least three columns: Name, Email, and Company Name");
                    hideLoader();
                    return;
                }
                setCsvColumns(csv_cols);
                setsubscribersName(csv_cols);
                setsubscribersEmail(csv_cols)
                setsubscribersCompanyName(csv_cols)
                setformValues({
                    ...formValues, csv_file: files[0],

                })
                // if (data[0].includes(".com") === false) {
                // } else {
                //     setsubscribersLength(data.length);
                // }
                setTimeout(() => {
                    hideLoader()
                    setmappingFieldModal(true)
                    // setShow({show:false})
                    setShowExportModal(false);
                }, 300);
            }
        }
        else {
            toast.error("Please upload a csv file")
            hideLoader()
        }
    }
    const nextStep = () => {
        if (importType == 'manual') {
            if (!formValues.name) {
                toast.error("Please enter name");
                return;
            }
            if (!formValues.company_name) {
                toast.error("Please enter company name");
                return;
            }
            if (!formValues.email) {
                toast.error("Please enter email address");
                return;
            }
            duplicateCheck('manual');
            // setsubscribersLength(1);
            // setRowsData({duplicate:0,total_pages:1})
        }else{
            if (!uploadedFile) {
                toast.error("Please upload a csv file");
                return;
            }else {
                mappingFile(uploadedFile)
            }
        }
        // setModalStep(2);
        // $('#importLeads').removeClass('active show');
        // $('#btnPageProfile2').removeClass('active show');
        // $('#generate').addClass('active show');
        // $('#btnPageTheme').addClass('active show');
    };
    const handleSubmit = (e = null, from = null) => {
        if (e && typeof e.preventDefault === 'function') {
            e.preventDefault();
        }
        showLoader()
        const api = apiUrl + "/community/subscribers/import";

        const formData = createFormdataValues(formValues);
        // console.log("formData",formValues)
        const myHeaders = new Headers();
        myHeaders.append("Authorization", `Bearer ${localStorage?.getItem("token")}`)
        if (importType == 'manual') {
            formData.append("from", 'manually')
        }
        // console.log("from",from)
        formData.append("campaign", product_id)
        const setOptions = {
            headers: myHeaders,
            body: formData,
            method: 'POST'
        }

        const errorList = []

        fetch(api, setOptions).then(async (res) => {
            const response = await res.json();
            if (response?.status_code == 200) {
                toast?.success(response?.status_message);
                hideLoader();
                setShowExportModal(true);
                setmappingFieldModal(false);
                // callAudience();
                setsubscribersLength(response?.data?.subscribersCount)
                setCredits(response?.data?.credits)
            } else {
                if (response?.errors?.csv_file?.length > 0) {
                    errorList.push(response?.errors?.csv_file);
                    setError(errorList);
                } else {
                    setError(Object.values(response?.errors));
                    if (Object.keys(response?.errors).length > 0)
                        $(".modal-body").scrollTop(0);
                }
                toast?.error(response?.status_message)
                hideLoader();
            }
        }).catch((error) => {
            toast?.error(error)
            hideLoader()

        })

    }
    const handleManuallyChange = (e) => {
        setformValues({ ...formValues, [e.target.name]: e.target.value });
    };
    const exportCSV = () => {
        if (!isGenerateDisabled) {
        showLoader();
        const api = apiUrl + "/community/subscribers/export";
        const formdata = createFormdataValues(formValues);
        formdata.append("project", slug)
        formdata.append("campaign", product_id)
        if (importType == 'manual') {
            formdata.append("from", 'manually')
            formdata.append("manualData", JSON.stringify(manualData))
        }else {
            formdata.append("csvData", JSON.stringify(mappedData))
            for (const key in rowsData) {
                if (Object.hasOwnProperty.call(rowsData, key)) {
                    if (rowsData[key])
                        formdata.append(key, rowsData[key])
                }
            };
        }
        var myHeaders = new Headers();
        myHeaders.append("Authorization", `Bearer ${localStorage?.getItem("token")}`);
        const setOptions = {
            method: "POST",
            headers: myHeaders,
            body: formdata
        }
        audiencePosts(api, hideLoader, setOptions,"leads").then((response) => {
            // setShow(false)
            if (response?.status_code == 200) {
                dispatch({ type: "SET_CREDITS_DATA", payload: {
                    ...creditsDataReducer,
                    total_credits: response?.data?.total_credits,
                    used_credits_percentage: response?.data?.used_credits_percentage,
                } });
                // history.push(response?.data?.redirect_url)
                if (importType == 'manual') {
                    window.open(response?.data?.redirect_url, '_blank').focus();
                    closeModal()
                }else{
                    setShowProcessingText(true);
                }
                // history.push("/project/" + slug + "/leads");
            }
        }).catch((err) => {
            toast.error(err)
        })
        }
    }
    const handleCloseMapModal = () => {
        setUploadedFile(null)
        setMappedData([]);
        setShowProcessingText(false)
        setmappingFieldModal(false);
    };
    // const handleChangeSelect = (e) => setformValues({ ...formValues, [e.target.name]: e.target.value });
    const saveMapData = () => {
        // const mappedDataArray = [];

        // csvColumns.forEach((column, index) => {
        //     const selectBox = document.getElementById(`select-box-${index}`);
        //     const selectedValue = selectBox.value;

        //     mappedDataArray.push({ column: column, selectedValue: selectedValue });
        // });
        const requiredFields = ['lead_first_name', 'company_name', 'email'];
        const selectedValues = mappedData.map(item => item.selectedValue);
        const hasAllRequiredFields = requiredFields.every(field => selectedValues.includes(field));

        if (!hasAllRequiredFields) {
            toast.error('Please select lead_first_name, company_name, and email before continuing.');
            return;
        }
        // setMappedData(mappedDataArray);
        duplicateCheck('csv');
    };
    const duplicateCheck = (type) => {
        showLoader();
        const api = apiUrl + "/community/subscribers/duplicate-check";
        const formdata = createFormdataValues(formValues);
        formdata.append("project", slug)
        formdata.append("campaign", product_id)
        formdata.append("type", type)
        if(type == 'csv'){
            formdata.append("csvData", JSON.stringify(mappedData))
        }
        var myHeaders = new Headers();
        myHeaders.append("Authorization", `Bearer ${localStorage?.getItem("token")}`);
        const setOptions = {
            method: "POST",
            headers: myHeaders,
            body: formdata
        }
        audiencePosts(api, hideLoader, setOptions,"leads").then((response) => {
            // setShow(false)
            if (response?.status_code == 200) {
                setRowsData({duplicate:response?.data?.duplicate_count,total_pages:response?.data?.total_rows,unique_pages:response?.data?.unique_rows})
                // setsubscribersLength(response?.data?.unique_rows);
                setIsGenerateDisabled(response?.data?.unique_rows > 0 && response?.data?.unique_rows <= creditsDataReducer?.total_credits ? false : true)
                setModalStep(2);
                setmappingFieldModal(false);
                setShowExportModal(true);
            } else {
                if (response?.errors?.csv_file?.length > 0) {
                    errorList.push(response?.errors?.csv_file);
                    setError(errorList);
                } else {
                    setError(Object.values(response?.errors));
                    if (Object.keys(response?.errors).length > 0)
                        $(".modal-body").scrollTop(0);
                }
                toast?.error(response?.status_message)
                hideLoader();
            }
        }).catch((err) => {
            toast.error(err)
        })
    }
    useEffect(() => {
        if (show?.show && !mappingFieldModal) {
            setModalStep(1);
            setShowExportModal(true);
            setImportType("csv")
        }
    }, [show])
    // console.log("setImportType",importType)
    const closeModal = () => {
        setformValues({project:slug,remove_duplicate:true})
        setCsvColumns([]);
        setMappedData([]);
        setManualData({});
        setUploadedFile(null);
        setRowsData({duplicate:0,total_pages:0,unique_pages:0})
        setShowProcessingText(false)
        setModalStep(null);
    };
    const handleSelectValue = (index, selectedValue) => {
        if (selectedValue !== 'ignore' && mappedData.some(item => item?.selectedValue === selectedValue)) {
            return;
        }
        const updatedMappedData = [...mappedData];
        for (let i = 0; i <= index; i++) {
            if (!updatedMappedData[i]) {
                updatedMappedData[i] = { column: csvColumns[i], selectedValue: 'ignore' };
            }
        }
        updatedMappedData[index] = { column: csvColumns[index], selectedValue };
        setMappedData(updatedMappedData);
    };
    const handleAddVariable = () => {
        // Append the new variable to your array
        if (newVariable && newVariable?.trim() && !variables.includes(newVariable)) {
            showLoader();
            var myHeaders = new Headers();
            myHeaders.append("Authorization", `Bearer ${localStorage?.getItem("token")}`);
            var formdata = new FormData();
            formdata.append("project", slug)
            formdata.append("new_variable", newVariable)
            const api = apiUrl + '/project/add-variable';
            const setOptions = {
                headers: myHeaders,
                body: formdata,
                method: 'POST'
            }
            fetch(api, setOptions).then(async (res) => {
                const response = await res.json();
                if (response?.status_code == 200) {
                    dispatch({type: "SET_VARIABLES", payload: [...variables,newVariable]})
                    setNewVariable('');
                    toast.success(response?.status_message);
                    hideLoader();
                } else {
                    setError(Object.values(response?.errors));
                    toast?.error(response?.status_message)
                    hideLoader();
                }
            }).catch((error) => {
                toast?.error(error)
                hideLoader()
    
            })
        }else {
            toast.error("Please add a valid variable");
        }
      };
    const handleManuallyVariableChange = (e) => {
        const { name, value } = e.target;
        setManualData(prevData => ({
            ...prevData,
            [name]: value !== null && value !== "" ? value : null,
        }));
    };
    const handleCheckboxChange = (e) => {
        const { name, checked } = e.target;
        if (checked) {
            setIsGenerateDisabled(rowsData?.unique_pages > 0 && rowsData?.unique_pages <= creditsDataReducer?.total_credits ? false : true)
        }else {
            setIsGenerateDisabled(rowsData?.total_pages > 0 && rowsData?.total_pages <= creditsDataReducer?.total_credits ? false : true)
        }
        setformValues(prevData => ({
           ...prevData,
            [name]: checked,
        }));
    };
    return (
        <>
            {/* <Modal className="customizeExportModal"
            show={showExportModal} onHide={handleClose} size={"lg"} id="customizePageModal">
            <div class="modal-dialog-centered modal-xlarge" role="document">
                <div class="modal-content p-0">

                    <div class="modal-body p-0">

                    <div class="customize-page-desktop customize-export-modal custom-u">
                        <button class="btn close-btn" data-bs-dismiss="modal" onClick={handleClose}>
                            <img src={closeIcon} width="15px" alt="" />
                        </button>
                        <div className="fade-u"></div>

                        <div class="left-bar nav nav-tabs export-nav-bar" role="tablist">
                            <div className="export-modal-menus flex-column  d-flex">
                                <div class="customize-page-menu-link active custom-width-u customizePageProfile" id="btnPageProfile2" >
                                    <div class="counter">1</div>
                                    <h6 class="pt-1 mb-0 ms-2">Import Leads</h6>
                                </div>
                                <div class="customize-page-menu-link custom-width-u customizePageTheme" id="btnPageTheme" >
                                    <div class="counter">2</div>
                                    <h6 class="pt-1 mb-0 ms-2">Generate + Download</h6>
                                </div>
                            </div>
                            <div className="export-modal-dots-image" style={{padding:"0 20px"}}>
                                <img width={"100%"} src={dots} alt="" />
                            </div>
                        </div>
                        <div class="tab-content position-relative ">
                            <div class="tab-pane fade active show p20-u" id="importLeads" role="tabpanel" aria-labelledby="btnPageProfile2">
                                <section>
                                    <h4 className="productHead1">Import Leads</h4>
                                    <div className="form-group w-100 p-0 mt-3">
                                        <label className="productlabels">Import</label>
                                        <div className="d-flex justify-content-between up-in-toggle bg-white import-leads price_type_check mt-2 p-0">
                                            <input type="radio" id="switch_left" name="importType" defaultChecked value="csv" onChange={() => toggleImportType("csv")} />
                                            <label htmlFor="switch_left" className="d-flex align-items-start flex-column w-50">
                                                <span className="w-100 d-flex align-items-center justify-content-between">
                                                    <h5 className="m-0 font-weight-500 pricing-text productlabel2">Upload CSV</h5>
                                                </span>
                                                <h6 className="productlabel3">Upload bulk leads</h6>
                                            </label>
                                            <input type="radio" id="switch_right" name="importType" value="manual" onChange={() => toggleImportType("manual")} />
                                            <label htmlFor="switch_right" className="d-flex align-items-start flex-column w-50">
                                                <span className="w-100 d-flex align-items-center justify-content-between">
                                                    <h5 className="m-0 font-weight-500 pricing-text productlabel2">Enter Manually</h5>
                                                </span>
                                                <h6 className="productlabel3">Enter Manually</h6>
                                            </label>
                                        </div>
                                    </div>
                                    <div className="form-group w-100 p-0 mt-3">
                                    <ErrorMessage error={error} />
                                    {
                                    importType == 'csv' ? 
                                    <>
                                        <div className="productlabels">Upload file</div>
                                        {!uploadedFile ?<>
                                        <input type="file" class="d-none dropzone" name="csv_file" ref={refUpload} accept=".csv" onChange={handleChange} />
                                        <button onClick={dropzoneWrapperClick} onDragOver={dropzoneWrapperDrag} onDragLeave={dropzoneWrapperLeave} onDrop={dropzoneWrapperDrop} type="button" class="project-upload-button">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M6 0C6.41421 0 6.75 0.335786 6.75 0.75V5.25H11.25C11.6642 5.25 12 5.58579 12 6C12 6.41421 11.6642 6.75 11.25 6.75H6.75V11.25C6.75 11.6642 6.41421 12 6 12C5.58579 12 5.25 11.6642 5.25 11.25V6.75H0.75C0.335786 6.75 0 6.41421 0 6C0 5.58579 0.335786 5.25 0.75 5.25H5.25V0.75C5.25 0.335786 5.58579 0 6 0Z" fill="#333333"/>
                                            </svg>
                                            <span class="upload-text">Upload New</span>
                                        </button></>
                                        :
                                            <small>{uploadedFile[0]?.name}</small>
                                        }
                                    </>
                                    :
                                    <>
                                        <div className="d-flex flex-column gap-2 ">
                                            <input
                                                type="text"
                                                className="zaapGlobal-input"
                                                onChange={(e)=>handleManuallyChange(e)}
                                                name="name"
                                                placeholder="Lead Name"
                                                value={formValues?.name}
                                            />
                                            <input
                                                type="email"
                                                className="zaapGlobal-input"
                                                onChange={(e)=>handleManuallyChange(e)}
                                                name="email"
                                                placeholder="Lead Email"
                                                value={formValues?.email}
                                            />
                                            <input
                                                type="text"
                                                className="zaapGlobal-input"
                                                onChange={(e)=>handleManuallyChange(e)}
                                                name="company_name"
                                                placeholder="Company Name"
                                                value={formValues?.company_name}
                                            />
                                        </div>
                                    </>

                                    }
                                    </div>
                                    <div class="text-center mt-4 d-flex submit-buttons-fixed">
                                    <button type="button" onClick={(e) =>nextStep()} className="project-blue-btn">
                                            <b class="me-2 productlabel2">Next Step</b>
                                            <small class="project-blue-btn-badge">
                                                <img src={returnIcon} alt="" />
                                            </small>
                                        </button>
                                    </div>
                                </section>
                            </div>
                            <div class="tab-pane fade p20-u" id="generate" role="tabpanel" aria-labelledby="btnPageTheme">
                                <section>
                                    <h4 className="productHead1">Generate + Download</h4>
                                    <div className="form-group w-100 p-0 mt-3">
                                        <div className="generate-download">
                                            <div>This export will use</div>
                                            <div className="btn-gradient">{subscribersLength} Credits</div>
                                            <div>You Have {credits} Credits Remianing</div>
                                        </div>
                                    </div>
                                    <div class="text-center mt-4 d-flex submit-buttons-fixed">
                                        <button onClick={exportCSV} type="button" class="project-blue-btn w-100">
                                            <b class="me-2 productlabel2">Export + Download</b>
                                            <small class="project-blue-btn-badge">
                                                <img src={returnIcon} alt="" />
                                            </small>
                                        </button>
                                    </div>
                                </section>
                            </div>
                        </div>

                    </div>

                    </div>

                </div>
            </div>
        </Modal> */}
            <Modal centered show={modalStep == 1 ? true : false} onHide={closeModal} className="import-modal import-step1-modal">
                <div class="modal-header create-biolink-header">
                    <h5 class="modal-title create-biolink-heading">Import Leads</h5>
                    <button type="button" class="close" onClick={closeModal} aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>

                <div class="modal-body d-flex  flex-column justify-content-between ">
                    <div>
                        <div className="form-group w-100 p-0 mt-3">
                            <div class="up-in-toggle bg-f1f1f1 w-50 btn-semi-rounded" style={{ padding: "5px 3px" }}>
                                <input type="radio" id="text_align_left" name="importType" defaultChecked style={{ display: "none" }} value="csv" onChange={() => toggleImportType("csv")} />
                                <label for="text_align_left" class="btn-semi-rounded toggletext newsletter-btn-semi-rounded " >Upload CSV</label>
                                <input type="radio" id="text_align_right" name="importType" style={{ display: "none" }} value="manual" onChange={() => toggleImportType("manual")} />
                                <label for="text_align_right" class="btn-semi-rounded toggletext newsletter-btn-semi-rounded "  > Enter Manually</label>
                            </div>
                        </div>
                        <div className="form-group w-100 p-0 mt-20px">
                            <ErrorMessage error={error} />
                            {
                                importType == 'csv' ?
                                    <>
                                        <div className="upload-csv" onDragOver={!uploadedFile ? dropzoneWrapperDrag : null} onDragLeave={!uploadedFile ? dropzoneWrapperLeave : null} onDrop={!uploadedFile ? dropzoneWrapperDrop : null}>
                                        {!uploadedFile ? <>
                                            <div className="text-center">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="21" viewBox="0 0 22 21" fill="none">
                                                    <path d="M7 14.5L11 10.5M11 10.5L15 14.5M11 10.5V19.5M19 15.2428C20.2215 14.234 21 12.7079 21 11C21 7.96243 18.5376 5.5 15.5 5.5C15.2815 5.5 15.0771 5.386 14.9661 5.19774C13.6621 2.98484 11.2544 1.5 8.5 1.5C4.35786 1.5 1 4.85786 1 9C1 11.0661 1.83545 12.9371 3.18695 14.2935" stroke="#333333" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                                </svg>
                                                <div>
                                                Drop a file or click to browse
                                                </div>
                                                <div onClick={closeModal} className="csv-droparea" onDragOver={dropzoneWrapperDrag} onDragLeave={dropzoneWrapperLeave} onDrop={dropzoneWrapperDrop}>
                                                </div>
                                            </div>
                                            <input type="file" class="d-none dropzone" name="csv_file" ref={refUpload} accept=".csv" onChange={handleChange} />
                                            <button onClick={dropzoneWrapperClick} onDragOver={dropzoneWrapperDrag} onDragLeave={dropzoneWrapperLeave} onDrop={dropzoneWrapperDrop} type="button" class="project-upload-button">
                                                Upload a .CSV file
                                            </button></>
                                            :
                                            <small>{uploadedFile[0]?.name}</small>
                                        }
                                    </div>
                                    </>
                                    :
                                    <>
                                        <div className="d-flex flex-column gap-2 ">
                                            <input
                                                type="text"
                                                className="zaapGlobal-input"
                                                onChange={(e) => handleManuallyChange(e)}
                                                name="name"
                                                placeholder="Lead Name"
                                                value={formValues?.name}
                                            />
                                            <input
                                                type="email"
                                                className="zaapGlobal-input"
                                                onChange={(e) => handleManuallyChange(e)}
                                                name="email"
                                                placeholder="Lead Email"
                                                value={formValues?.email}
                                            />
                                            <input
                                                type="text"
                                                className="zaapGlobal-input"
                                                onChange={(e) => handleManuallyChange(e)}
                                                name="company_name"
                                                placeholder="Company Name"
                                                value={formValues?.company_name}
                                            />
                                            {
                                                variables?.slice(4).map((val, index) => (
                                                    <input
                                                    type="text"
                                                    className="zaapGlobal-input"
                                                    onChange={(e) => handleManuallyVariableChange(e, val)}
                                                    name={val}
                                                    placeholder={val}
                                                    value={manualData[index] && manualData[index][val]}
                                                    />
                                                ))
                                            }
                                        </div>
                                    </>

                            }
                        </div>
                    </div>
                    <div class="text-center mt-4 d-flex submit-buttons-fixed gap-2">
                        <button type="button" onClick={closeModal} className="w-50 mt-0 integration-btns integration-btn-grey">
                            <b class="me-2 productlabel2">Cancel</b>
                            <small>
                                <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
                                    <path d="M9 1L1 9M1 1L9 9" stroke="#333333" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                            </small>
                        </button>
                        <button type="button" onClick={(e) => nextStep()} className="w-50 project-blue-btn">
                            <b class="me-2 productlabel2">Next Step</b>
                            <small class="project-blue-btn-badge">
                                <img src={returnIcon} alt="" />
                            </small>
                        </button>
                    </div>
                </div>
            </Modal>
            <Modal centered show={modalStep == 2 ? true : false} onHide={closeModal} className="import-modal">
                <div class="modal-content pt-0 pl-0 pr-0 pb-0">
                    <div class="modal-header create-biolink-header">
                        <h5 class="modal-title create-biolink-heading">Map CSV Fields</h5>
                        <button type="button" class="close" onClick={closeModal} aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>

                    <div class="modal-body">
                    {!showProcessingText ? (
                    <>
                        <div className="form-group w-100 p-0 mt-3">
                            <div className="generate-download">
                                <div>Generate {formValues?.remove_duplicate ? rowsData?.unique_pages : rowsData?.total_pages} Lead Pages</div>
                                {rowsData?.duplicate > 0 ? (
                                    <div>
                                        <label className="custom-checkbox checkbox me-0 pe-0">
                                            <input type="checkbox" defaultChecked name="remove_duplicate" onChange={handleCheckboxChange}/>
                                            <span className="checkmark"></span>
                                        </label>
                                       <span> Remove {rowsData?.duplicate} leads found in campaign already </span>
                                    </div>
                                ) : (
                                    <div>No duplicate leads found for this campaign</div>
                                )}
                                <div className="credits-info mt-20px">
                                    <div className="d-flex align-items-center gap-1">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="23" height="22" viewBox="0 0 23 22" fill="none">
                                            <rect x="1" y="0.5" width="21" height="21" rx="6.5" fill="#FFF7DD" />
                                            <rect x="1" y="0.5" width="21" height="21" rx="6.5" stroke="#FFF3C7" />
                                            <path d="M13.4689 12.9689C15.1802 12.7398 16.5 11.274 16.5 9.5C16.5 7.567 14.933 6 13 6C11.226 6 9.76024 7.31983 9.53113 9.03113M9.25 11.5L10 11V13.75M9.25 13.75H10.75M13.5 12.5C13.5 14.433 11.933 16 10 16C8.067 16 6.5 14.433 6.5 12.5C6.5 10.567 8.067 9 10 9C11.933 9 13.5 10.567 13.5 12.5Z" stroke="#FFCE22" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                        <span>This export will use {formValues?.remove_duplicate ? rowsData?.unique_pages : rowsData?.total_pages} Credits</span>
                                    </div>
                                    <div className="d-flex align-items-center gap-2">
                                        <span>{creditsDataReducer?.total_credits} Credits Remaining</span>
                                        <NavLink to={`${basePath}/settings`}  className="p-0 blue-text-navigate">
                                            Manage Plan
                                            <svg xmlns="http://www.w3.org/2000/svg" width="7" height="7" viewBox="0 0 7 7" fill="none">
                                                <path d="M0.5 6.5L6.5 0.5M6.5 0.5H2.5M6.5 0.5V4.5" stroke="#1188FF" strokeLinecap="round" strokeLinejoin="round" />
                                            </svg>
                                        </NavLink>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="text-center mt-4 w-100 d-flex gap-1 align-items-center submit-buttons-fixed">
                            <button type="button" onClick={closeModal} className="w-50 mt-0 integration-btns integration-btn-grey">
                                Close
                            </button>
                            <button
                                disabled={isGenerateDisabled}
                                onClick={isGenerateDisabled ? null : exportCSV}
                                type="button"
                                className="w-50 project-blue-btn shadow-none"
                            >
                                {(formValues?.remove_duplicate && rowsData?.unique_pages > creditsDataReducer?.total_credits ) || (!formValues?.remove_duplicate && rowsData?.total_pages > creditsDataReducer?.total_credits) ?  'Upgrade': 'Export + Download'}
                            </button>
                        </div>
                    </>
                ) : (
                    <>
                        <div className="form-group w-100 p-0 mt-3">
                            <div className="generate-download">
                                <div>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
                                        <rect x="0.5" y="0.5" width="21" height="21" rx="6.5" fill="#FFF7DD" />
                                        <rect x="0.5" y="0.5" width="21" height="21" rx="6.5" stroke="#FFF3C7" />
                                        <path d="M7.25 16V13.5M7.25 8.5V6M6 7.25H8.5M6 14.75H8.5M11.5 6.5L10.6329 8.75443C10.4919 9.12105 10.4214 9.30435 10.3118 9.45854C10.2146 9.5952 10.0952 9.71459 9.95854 9.81176C9.80435 9.9214 9.62105 9.99191 9.25443 10.1329L7 11L9.25443 11.8671C9.62105 12.0081 9.80435 12.0786 9.95854 12.1882C10.0952 12.2854 10.2146 12.4048 10.3118 12.5415C10.4214 12.6956 10.4919 12.879 10.6329 13.2456L11.5 15.5L12.3671 13.2456C12.5081 12.879 12.5786 12.6956 12.6882 12.5415C12.7854 12.4048 12.9048 12.2854 13.0415 12.1882C13.1956 12.0786 13.379 12.0081 13.7456 11.8671L16 11L13.7456 10.1329C13.379 9.99191 13.1956 9.9214 13.0415 9.81176C12.9048 9.71459 12.7854 9.5952 12.6882 9.45854C12.5786 9.30435 12.5081 9.12105 12.3671 8.75443L11.5 6.5Z" stroke="#FFCE22" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                    <span className="ms-1 align-middle">Your export is processing</span>
                                </div>
                                <div>If you stay on this page, you’ll automatically be <br /> redirected to the leads page. We’ll send you an email <br /> with a link to view your export once complete.</div>
                            </div>
                        </div>
                        <div className="text-center mt-4 gap-1 align-items-center d-flex w-100 submit-buttons-fixed">
                            <button type="button" onClick={closeModal} className="w-50 mt-0 integration-btns integration-btn-grey">
                                Cancel
                            </button>
                            <button type="button" onClick={closeModal} className="w-50 project-blue-btn shadow-none">
                                Close
                            </button>
                        </div>
                    </>
                )}
                    </div>
                </div>
            </Modal>
            <Modal centered show={mappingFieldModal} onHide={handleCloseMapModal} className="import-modal">
                <div class="modal-content pt-0 pl-0 pr-0 pb-0">
                    <div class="modal-header create-biolink-header">
                        <h5 class="modal-title create-biolink-heading">Map CSV Fields</h5>
                        <button type="button" class="close" onClick={handleCloseMapModal} aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>

                    <div class="modal-body">
                        <form name="import_subscribers_form" id="import_subscribers_form">
                            <div className=" d-flex justify-content-between flex-column">
                                <div class="notification-container"></div>
                                <ErrorMessage error={error} />
                                <div className="csv-col-map overflow-auto  hidden-scroll">
                                    <div className="csv-col-map-fields">
                                        <span className="w-50">CSV Fields:</span>
                                        <span className="ms-1">Variable:</span>
                                    </div>
                                    {
                                        csvColumns?.map((value, index) => (
                                            <div className="csv-col-map-fields">
                                                <span class="zaapGlobal-input">{value}</span>
                                                <span>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="10" height="8" viewBox="0 0 10 8" fill="none">
                                                        <path d="M0.5 4H9.5M9.5 4L6.104 1M9.5 4L6.104 7" stroke="#666666" stroke-linecap="round" stroke-linejoin="round" />
                                                    </svg>
                                                </span>
                                                <div class="table-action-dropdown d-flex justify-content-between gap-2 zaapGlobal-input dropdown-toggle noselect d-flex align-items-center dropdown-subscribers" id="table-action-dropdown" data-bs-toggle="dropdown" aria-expanded="false" >
                                                <span className="d-flex gap-2 align-items-center ">
                                                    {mappedData[index]?.selectedValue && mappedData[index]?.selectedValue !== 'ignore' ?
                                                        <span className="box-18f"></span>:
                                                        <span className="small-box bg-danger"></span>
                                                    }
                                                    <span className="me-5">
                                                        {mappedData[index]?.selectedValue || 'ignore'}
                                                    </span>
                                                </span>
                                                </div>
                                                <ul class="dropdown-menu project-dropdown-menu" aria-labelledby="table-action-dropdown">
                                                    {variables?.length > 0 && (
                                                        variables.map((val, idx) => (
                                                            <li key={idx} onClick={() => handleSelectValue(index, val)}>
                                                                <a class={`dropdown-item variable-dropdown-item cursor-pointer d-flex align-items-center justify-content-between ${val !== 'ignore' && mappedData.some(item => item?.selectedValue == val) ? 'disabled' : ''}`} >
                                                                    <span className="me-5">{val} </span>
                                                                    <svg xmlns="http://www.w3.org/2000/svg" width="6" height="10" viewBox="0 0 6 10" fill="none">
                                                                        <path d="M0.339129 1.24778C0.7913 0.871025 1.52442 0.871025 1.97659 1.24778L5.66087 4.31756C6.11304 4.69431 6.11304 5.30515 5.66087 5.6819C5.2087 6.05865 4.47558 6.05865 4.02341 5.6819L0.339129 2.61212C-0.113043 2.23537 -0.113043 1.62453 0.339129 1.24778Z" fill="#333333"/>
                                                                        <path d="M5.66087 4.31756C6.11304 4.69431 6.11304 5.30515 5.66087 5.6819L1.97715 8.75161C1.52498 9.12837 0.791862 9.12837 0.339691 8.75161C-0.112481 8.37486 -0.112481 7.76402 0.339691 7.38727L4.02397 4.31749C4.47615 3.94074 5.2087 3.9408 5.66087 4.31756Z" fill="#333333"/>
                                                                    </svg>
                                                                </a>
                                                            </li>
                                                        ))
                                                    )}
                                                </ul>
                                            </div>
                                        ))
                                    }
                                </div>
                                <div>
                                    <div className="d-flex align-items-center zaapGlobal-input ps-2 p-0 w-auto" >
                                        <input type="text" value={newVariable} onChange={(e)=>setNewVariable(e.target.value)} placeholder="Add new variable"  />
                                        <button type="button" className="project-blue-btn" onClick={handleAddVariable}>Add</button>
                                    </div>
                                    <div class="text-center mt-4 d-flex submit-buttons-fixed gap-2" >
                                        <button type="button" onClick={handleCloseMapModal} class="project-grey-button">
                                            Cancel
                                            <small className="exit-badge">Esc</small>
                                        </button>
                                        <button type="button" onClick={saveMapData} name="submit" class="project-blue-btn">
                                            <span class="productlabel2">Continue</span>
                                            <small class="project-blue-btn-badge">
                                                <img src={returnIcon} alt="" />
                                            </small>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </Modal>
        </>
    )
}
export default ExportSteps